import { render, staticRenderFns } from "./registerScreen.vue?vue&type=template&id=7d9b22f6&scoped=true&"
import script from "./registerScreen.vue?vue&type=script&lang=js&"
export * from "./registerScreen.vue?vue&type=script&lang=js&"
import style0 from "./registerScreen.vue?vue&type=style&index=0&id=7d9b22f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d9b22f6",
  null
  
)

export default component.exports